<template>
  <div id="blog" class="blog-wrap pb-75">
    <div class="container">
      <div class="row">
        <div class="col-lg-8 offset-lg-2">
          <div class="section-title style1 text-center mb-40">
            <span>Blog &amp; News</span>
            <h2>Read Our Latest News & Articles</h2>
          </div>
        </div>
      </div>

      <div class="row justify-content-center">
        <div
          class="col-xl-4 col-lg-6 col-md-6"
          v-for="blog in blogs"
          :key="blog.id"
        >
          <div class="blog-card style5">
            <div class="blog-img">
              <img :src="blog.image" alt="Image" />
              <span class="blog-date">{{ blog.date }}</span>
            </div>

            <div class="blog-info">
              <ul class="blog-metainfo list-style">
                <li>
                  <i class="ri-user-add-line"></i>
                  <a href="#">{{ blog.user }}</a>
                </li>
                <li>
                  <i class="ri-chat-4-line"></i>
                  <a href="#">No Comment</a>
                </li>
              </ul>
              <h3>
                <router-link to="/blog-details">
                  {{ blog.title }}
                </router-link>
              </h3>
              <p>
                {{ blog.shortDesc }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "LatestNews",
  data: () => ({
    blogs: [
      {
        id: 1,
        image: require("../../assets/images/blog/blog-10.jpg"),
        user: "Admin",
        date: "29 June, 2023",
        title: "Whatever You Do, Make Sure It Leads You To Happy Life",
        shortDesc:
          "Lorem Ipsum is simply dummy text of the and standard dummy text ever since when.",
      },
      {
        id: 2,
        image: require("../../assets/images/blog/blog-11.jpg"),
        user: "Admin",
        date: "28 June, 2023",
        title: "The Day I'd Spent At The Square Medical Facility Center",
        shortDesc:
          "Lorem Ipsum is simply dummy text of the and standard dummy text ever since when.",
      },
      {
        id: 3,
        image: require("../../assets/images/blog/blog-12.jpg"),
        user: "Admin",
        date: "27 June, 2023",
        title: "How Does Science Help In Dental Surgery Research",
        shortDesc:
          "Lorem Ipsum is simply dummy text of the and standard dummy text ever since when.",
      },
    ],
  }),
});
</script>